import classnames from 'classnames/bind'
import Image from 'next/image'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  src: string
  size?: number
}

/** 分類 icon（多為 svg：next/image 的 optimizer 不處理 svg，改 unoptimized 直接載入） */
const CollectionIcon = ({ src, size = 40 }: Props) => (
  <span className={cx('help-collection-icon')} style={{ width: size, height: size }}>
    {src ? <Image src={src} alt='' width={size} height={size} unoptimized /> : <i className='icon-search' aria-hidden />}
  </span>
)

export default CollectionIcon
